import React, { useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ReceiptText, ArrowLeft, CreditCard, Loader2 } from "lucide-react";
import { DocumentAutofill, mapDocToAnagrafica } from "@/components/DocumentAutofill";
import { useNavigate } from "react-router-dom";

const EMPTY = { avviso_pa: "", ente_pa: "", importo: "", email: "", nome: "", cognome: "", telefono: "" };

export default function BollettiniCliente() {
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [paying, setPaying] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const onDocData = (d) => { const a = mapDocToAnagrafica(d); setForm((f) => ({ ...f, nome: a.nome || f.nome, cognome: a.cognome || f.cognome })); };

  const pay = async () => {
    if (!form.avviso_pa.trim() || !form.ente_pa.trim() || !form.email.includes("@") || !(parseFloat(form.importo) > 0)) {
      toast.error("Compila codice avviso, ente/CBILL, importo ed email valida"); return;
    }
    setPaying(true);
    try {
      const { data } = await api.post("/openapi/bollettini/customer-checkout", {
        email: form.email.trim(), importo: parseFloat(form.importo), ente_pa: form.ente_pa.trim(),
        avviso_pa: form.avviso_pa.trim(), nome: form.nome || undefined, cognome: form.cognome || undefined, telefono: form.telefono || undefined,
      });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore nel pagamento"); setPaying(false); }
  };

  return (
    <div className="space-y-6 max-w-xl" data-testid="bollettini-cliente-page">
      <button onClick={() => navigate("/app/servizi")} className="app-text-button flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground" data-testid="bollettini-back"><ArrowLeft className="w-4 h-4" /> Servizi</button>
      <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Bollettini / PagoPA</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1 flex items-center gap-2"><ReceiptText className="w-7 h-7 text-blue-500" /> Paga un avviso pagoPA</h1>
        <p className="text-sm text-muted-foreground mt-1">Paghi la commissione di servizio con carta; poi completi il pagamento dell'avviso sulla pagina pagoPA sicura (link inviato anche via email).</p>
      </div>

      <Card className="p-6 glow-border space-y-4">
        <DocumentAutofill tipoCliente="privato" onData={onDocData} />
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Codice avviso *</Label><Input className="mt-1.5" data-testid="boll-avviso" value={form.avviso_pa} onChange={set("avviso_pa")} placeholder="18 cifre" /></div>
          <div><Label>Ente / CBILL *</Label><Input className="mt-1.5" data-testid="boll-ente" value={form.ente_pa} onChange={set("ente_pa")} /></div>
          <div><Label>Importo bollettino (€) *</Label><Input type="number" step="0.01" className="mt-1.5" data-testid="boll-importo" value={form.importo} onChange={set("importo")} /></div>
          <div><Label>Email *</Label><Input type="email" className="mt-1.5" data-testid="boll-email" value={form.email} onChange={set("email")} placeholder="nome@email.it" /></div>
          <div><Label>Nome</Label><Input className="mt-1.5" data-testid="boll-nome" value={form.nome} onChange={set("nome")} /></div>
          <div><Label>Cognome</Label><Input className="mt-1.5" data-testid="boll-cognome" value={form.cognome} onChange={set("cognome")} /></div>
        </div>
        <p className="text-xs text-muted-foreground">L'importo dell'avviso ({form.importo ? euro(parseFloat(form.importo) || 0) : "—"}) si paga sulla pagina pagoPA. Con carta ora paghi solo la commissione di servizio.</p>
        <Button onClick={pay} disabled={paying} className="gap-2 w-full" data-testid="boll-pay">
          {paying ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />} Paga la commissione e continua
        </Button>
      </Card>
    </div>
  );
}
